import React from "react";

export function ChartTooltip({ active, payload, label, formatter }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="sd-tooltip">
      {label && <div className="sd-tooltip-label">{label}</div>}
      {payload.map((p, i) => (
        <div key={i} className="sd-tooltip-row">
          <span
            className="sd-tooltip-swatch"
            style={{ background: p.color || p.fill }}
          />
          <span className="sd-tooltip-name">{p.name}</span>
          <span className="sd-tooltip-value">
            {formatter ? formatter(p.value, p.name, p) : p.value}
          </span>
        </div>
      ))}
    </div>
  );
}
